import type { NumberString } from '@openx/types/helpers.ts';
import type { GetOrganizationsListQuery } from '../../../../graphql/query/organizations/GetOrganizationsList.generated.tsx';

export type OrganizationOptions = Record<NumberString, { id: number; name: string } | undefined>;

export const mapOrganizationsToId = (organizations: GetOrganizationsListQuery['account']): OrganizationOptions => {
  const orgOptions: OrganizationOptions = {};

  organizations.forEach(org => {
    const partner = org.exchange_account_partner;

    if (partner) {
      orgOptions[partner.id] = {
        id: partner.id,
        name: partner.name,
      };
    }
  });

  return orgOptions;
};
